import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";
import { useState } from "react";

export default function ShippingLabelModal({
  shipping,
  setModalOpen,
  modalOpen,
}) {
  const labelUrl = shipping?.shipping_metadatas?.items?.find(
    (item) => item.key === "label_url"
  )?.value;

  const [labelLoaded, setLabelLoaded] = useState(false);

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between max-h-[90vh] min-h-[550px]"
    >
      <>
        <div className="flex flex-col justify-between">
          <div className="flex justify-end">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              <img src={CloseIcon} alt="" variant="secondary" />
            </div>
          </div>
          <div className="flex flex-col space-y-3 w-full items-center">
            <img
              src="/static/media/logo.4f05a22b8fee49f8826e.jpg"
              alt="LEGO"
              className="w-12 h-12"
            />

            <h2 className="text-4xl font-semibold max-w-[260px] text-center leading-snug -mb-2">
              Present this shipping QR code at The UPS Store.
            </h2>

            <div className="relative flex items-center justify-center w-64 h-64">
              {/* Spinner */}
              <div
                id="qr-spinner"
                className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${labelLoaded ? "opacity-0" : "opacity-100"}`}
              >
                <div className="w-16 h-16 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
              </div>
              {/* QR Image */}
              <img
                src={labelUrl}
                alt="QR Code"
                className="max-w-64"
                style={{
                  objectFit: "cover",
                  objectPosition: "center",
                  clipPath: "inset(10% 3%)",
                  position: "relative",
                  zIndex: 1,
                }}
                onLoad={() => setLabelLoaded(true)}
                onError={() => setLabelLoaded(true)}
              />
              <span className="text-black-300 text-sm mt-8 absolute bottom-[-8px]">
                UPS code for reference
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-between mt-2">
          <Button
            className=""
            variant="secondary"
            onClick={() => setModalOpen(false)}
          >
            Back
          </Button>
          <Button className="" onClick={() => setModalOpen(false)}>
            Done
          </Button>
        </div>
      </>
    </Modal>
  );
}
